<template>
    <div class="forget-password">
        <div class="forget-password-title">
            <span>忘记密码</span>
        </div>
        <el-form :model="forgetPassword" :rules="forgetPasswordRules" ref="forgetPasswordForm" name="forgetPassword" key="forgetPassword">
            <el-form-item prop="email">
                <el-input
                    type="text"
                    name="email"
                    key="forgetPasswordEmail"
                    placeholder="邮箱账号"
                    v-model="forgetPassword.email"
                />
            </el-form-item>
            <el-form-item prop="vcode">
                <el-row>
                    <el-col :span="14">
                        <el-input
                            type="text"
                            name="vcode"
                            key="forgetPassword-vcode-input"
                            placeholder="验证码"
                            v-model="forgetPassword.vcode"
                        />
                    </el-col>
                    <el-col :span="9" :offset="1">
                        <el-button
                            type="primary"
                            style="width: 100%"
                            v-if="!vcodeIsSend"
                            :loading="vcodeBtnLoading"
                            @click="handleGetVcode"
                        >{{ vcodeBtnText }}</el-button>
                        <el-button
                            v-else
                            style="width: 100%"
                            disabled
                        >验证码已发送</el-button>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                    type="password"
                    name="password"
                    key="forgetPassword-password-input"
                    placeholder="密码"
                    show-password
                    v-model="forgetPassword.password"
                />
            </el-form-item>
            <el-form-item prop="repassword">
                <el-input
                    type="password"
                    name="repassword"
                    key="forgetPassword-repassword-input"
                    placeholder="确认密码"
                    show-password
                    v-model="forgetPassword.repassword"
                />
            </el-form-item>
            <el-button
                type="primary"
                style="width: 100%"
                :loading="forgetBtnLoading"
                @click="handleSubmit"
            >修改密码</el-button>
        </el-form>
        <div class="login__button">
            <span @click="changePage(0)">账号登录</span>
        </div>
    </div>
</template>

<script>
    import { getEmailCode, forgetPassword } from '@/api/login';

    export default {
        name: 'DialogForgetPassword',
        data() {
            const validateForgetPassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.forgetPassword.repassword !== '') {
                        this.$refs.forgetPasswordForm.validateField('repassword');
                    }
                    callback();
                }
            };
            const validateForgetRepassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.forgetPassword.password) {
                    callback(new Error('两次输入密码不一致'));
                } else {
                    callback();
                }
            };
            return {
                forgetPassword: {
                    email: '',
                    password: '',
                    repassword: '',
                    vcode: ''
                },
                forgetPasswordRules: {
                    email: [
                        { required: true, message: '请输入国内邮箱', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的国内邮箱地址', trigger: ['blur', 'change'] }
                    ],
                    password: [
                        { validator: validateForgetPassword, trigger: 'blur' },
                        { min: 6, max: 16, message: '密码长度为6-16个字符', trigger: ['blur', 'change'] }
                    ],
                    repassword: [
                        { validator: validateForgetRepassword, trigger: 'blur' }
                    ],
                    vcode: [
                        { required: true, message: '请输入验证码', trigger: 'blur' }
                    ]
                },
                vcodeIsSend: false,
                vcodeBtnText: '获取验证码',
                vcodeBtnLoading: false,
                forgetBtnLoading: false
            };
        },
        methods: {
            changePage(type) {
                this.$emit('changePage', type);
            },
            handleGetVcode() {
                this.$refs.forgetPasswordForm.validateField('email', err => {
                    if (!err) {
                        this.vcodeBtnText = '获取中';
                        this.vcodeBtnLoading = true;
                        getEmailCode({ email: this.forgetPassword.email })
                            .then(({ code }) => {
                                if (code === 0) {
                                    this.vcodeIsSend = true;
                                }
                            })
                            .catch(res => {
                                this.vcodeBtnText = '获取验证码';
                                this.$message.error(res.data.msg);
                            })
                            .finally(() => {
                                this.vcodeBtnLoading = false;
                            })
                    }
                });
            },
            handleSubmit() {
                this.$refs.forgetPasswordForm.validate(valid => {
                    if (valid) {
                        const params = {
                            email: this.forgetPassword.email,
                            password: this.forgetPassword.password,
                            code: this.forgetPassword.vcode
                        };
                        this.forgetBtnLoading = true;
                        forgetPassword(params)
                            .then(res => {
                                if (res.code === 0) {
                                    this.$message.success('修改成功，请重新登录');
                                    this.changePage(0);
                                }
                            })
                            .finally(() => {
                                this.forgetBtnLoading = false;
                            });
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
.forget-password {
    &-title {
        margin-bottom: 40px;
        @include font(rgba(47, 84, 235, 1), 20px, 600);
    }
    .login__button {
        margin-top: 20px;
        text-align: center;
        text-decoration: underline;
        @include font(rgba(47, 84, 235, 1), 16px, 400);

        span {
            cursor: pointer;
        }
    }
}
</style>
